import React from 'react'
import PropTypes from 'prop-types'

import { AppWrapper, Input, Text } from 'passiv-components'

import renderPortal from './portal'

const Reset = ({
  register,
  portal,
  loading,
  showForm,
  errorText,
  onBack,
  onResetPassword,
  onClickSuccess,
  onToggleModal
}) => {
  return (
    <AppWrapper
      dataContainer="reset"
      titleHeader="Reset Password"
      titleContainer={showForm ? 'Please enter your new password below' : 'Sorry'}
      loading={loading}
      renderPortal={renderPortal({
        ...portal,
        errorText,
        onClickSuccess,
        onToggleModal
      })}
      buttons={
        showForm
          ? [
              {
                name: 'resest-password',
                text: 'Reset Password',
                onClick: onResetPassword
              }
            ]
          : []
      }
      onBack={onBack}
    >
      {showForm ? (
        <>
          <Input
            ref={register({ required: true })}
            type="password"
            name="passwordOne"
            label="Password"
            className="border-b border-border-dark mb-1"
          />

          <Input
            ref={register({ required: true })}
            type="password"
            name="passwordTwo"
            label="Password"
            className="border-b border-border-dark mb-1"
          />
        </>
      ) : (
        <Text className="p-4 text-center">
          We cannot reset your password, the link has expired or invalid.
        </Text>
      )}
    </AppWrapper>
  )
}

Reset.propTypes = {
  register: PropTypes.func,
  loading: PropTypes.bool,
  showForm: PropTypes.bool,
  errorText: PropTypes.string,
  onResetPassword: PropTypes.func,
  onClickSuccess: PropTypes.func,
  onBack: PropTypes.func,
  onToggleModal: PropTypes.func
}

export default Reset
